import { render, staticRenderFns } from "./IngresantesDocentes.vue?vue&type=template&id=1e74edf1&scoped=true&"
import script from "./IngresantesDocentes.vue?vue&type=script&lang=js&"
export * from "./IngresantesDocentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74edf1",
  null
  
)

export default component.exports